import store from './store';

export function postView(project) {
  store.commit('setCurrentProject', project);
}



// WEBPACK FOOTER //
// ./assets/js/posts.js